import React from 'react';

const PALETTE = [
  { bg: '#D3F4E1', fg: '#0B7A55' },
  { bg: '#E5E7EE', fg: '#1B2B4B' },
  { bg: '#FDF6E7', fg: '#A67E15' },
  { bg: '#FDEDE9', fg: '#A5351F' },
  { bg: '#CDD2DE', fg: '#18263C' },
];

const hashHue = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) & 0xffffffff;
  }
  return Math.abs(h);
};

/**
 * Colored-initials avatar using the design-system warm palette.
 *
 * Props:
 *   name   – string used to derive initials & color
 *   size   – px (default 32)
 *   ring   – adds white ring for stacked avatars
 */
const Avatar = ({ name = '?', size = 32, ring = false }) => {
  const initials = (name || '?')
    .split(' ')
    .filter(Boolean)
    .map(n => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase() || '?';

  const p = PALETTE[hashHue(name) % PALETTE.length];

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold tnum flex-shrink-0 ${ring ? 'ring-2 ring-white' : ''}`}
      style={{
        width:           size,
        height:          size,
        backgroundColor: p.bg,
        color:           p.fg,
        fontSize:        size * 0.38,
      }}
    >
      {initials}
    </span>
  );
};

export default Avatar;
